<template>
  <modal :name="name" @before-open="beforeOpen" :width="360" :height="400" styles="overflow: visible">
    <div class="modal-import-from">
      <div class="close" @click="close"></div>
      <div class="content">
        <!--<div class="title">{{$t('import_config_from').replace('%config%',$t(optionType))}}</div>-->
        <div class="title">Import from</div>
        <template v-if="projects">
          <multi-select-component
            label="My Projects"
            mode="single"
            v-model="project"
            :options="projectOptions"
            class="selector"
          ></multi-select-component>
          <multi-select-component
            label="Trial in this project"
            mode="single"
            v-model="trial"
            :options="trialOptions"
            :disabled="!project"
            noOptions="No trial available for this project"
            class="selector"
          ></multi-select-component>
          <multi-select-component
            label="Groups in this trial (optional)"
            mode="single"
            v-model="group"
            :disabled="!trial"
            :options="groupOptions"
            class="selector"
            noOptions="No group available for this trial"
          ></multi-select-component>
          <label class="fake-checkbox-container">
            <input class="checkbox" type="checkbox" value="parameters" v-model="optionTypes">
            <div class="fake-checkbox"></div>
            {{$t('parameters')}}
          </label>
          <label class="fake-checkbox-container">
            <input class="checkbox" type="checkbox" value="diseases" v-model="optionTypes">
            <div class="fake-checkbox"></div>
            {{$t('diseases')}}
          </label>
          <label class="fake-checkbox-container">
            <input class="checkbox" type="checkbox" value="treatments" v-model="optionTypes">
            <div class="fake-checkbox"></div>
            {{$t('treatments')}}
          </label>
          <div class="accept-btn btn btn--primary" :class="{disabled: !project || !trial}" @click="done">{{$t('OK')}}</div>
        </template>
        <template v-else>
          Loading info...
        </template>
      </div>
    </div>
  </modal>
</template>

<script>

import MultiSelectComponent from '@/components/MultiSelectComponent'
import { getValueTypeKey, getOption, setOption} from '@/utils/ConfigUtils'
import Api from '@/api'
import trialConfig from '@/mixins/trialConfig'
import _ from 'underscore'

export default {
  props: ['name'],
  mixins: [trialConfig],
  components: {MultiSelectComponent},
  data(){
    return {
      optionTypes: ['parameters'],
      project: null,
      trial: null,
      group:null,
      importPopulation: true,
      importDisease: true,
      importTratment: true
    }
  },
  asyncComputed:{
    projects () {
      return Api.getProjects()
    },
    allGroups () {
      return this.project ? Api.getGroups(this.project) : []
    },
    currentTrial () {
      return (this.project && this.trial) ? Api.getTrialResults({project: this.project.id, trial: this.trial.id}) : []
    }
  },
  computed: {
    projectOptions(){
      return this.projects.map((p)=>({label: p.name, value: p}))
    },
    trialOptions () {
      if(!this.projectOptions || !this.project) return [{value:-1, label:"Select a project first"}]
      else {
        let proj = this.projects.find((p)=>p.id===this.project.id)
        return proj.trials.map((t)=>({label: t.name, value: t}))
      }
    },
    groupOptions () {
      if(!this.project || !this.trial) return [{value:-1, label:"Select a project first"}]
      else {
        let subjectIdsInTrial = this.currentTrial.map(s => s.subject.id)
        return this.allGroups.filter(g => _.intersection(g.subjectIds, subjectIdsInTrial).length > 0)
          .map((t)=>({
            label: `${t.name} (${_.intersection(t.subjectIds, subjectIdsInTrial).length} subjects)`,
            value: {
              ...t,
              subjetsInCurrentTrial: _.intersection(t.subjectIds, subjectIdsInTrial)
            }
          })
        )
      }
    }
  },
  methods:{
    beforeOpen(event) {
      //this.optionType = event.params.optionType
      this.trial = null
      this.project = null
    },
    done(){
      this.confirmOverwrite().then(() => {
        Api.getTrial({project: this.project.id, trial: this.trial.id}).then((result) => {
          let src = this.fillWithTemplateData(result)
          let optArray = {}
          this.optionTypes.forEach(opt => {
            optArray[opt] = getOption(src, opt)
            if(opt == 'parameters' && this.group) {
              optArray['originTemplateIds'] = this.group.subjetsInCurrentTrial.map(subjId => this.currentTrial.find(s => s.subject.id == subjId).subject.templateId)
            }
          })
          let text = ''
          if(this.trial){
            text += `Imported from Trial ${this.trial.name}`
          } 
          if(this.group){
            text += `, Group ${this.group.name}`
          } 

          this.$emit('done', {optArray: optArray, text: text})
          this.close()
        })
      })
    },
    confirmOverwrite(){
      return new Promise((res,rej)=>{
        if(this.optionTypes.length>0){
          this.$modal.show('dialog', {
            title: 'Warning',
            text:`You are going to import ${this.optionTypes.map(opt => this.$t(opt)).join(', ')} from another trial. All existing configurations will be lost!`,
            buttons: [
              {
                title: 'Cancel',
                handler: () => {
                  rej()
                  this.$modal.hide('dialog')
                }
              },
              {
                title: 'Understood',
                handler: () => {
                  res()
                  this.$modal.hide('dialog')
                }
              }
            ]
          })
        } else {
          res()
        }
      })
    },
    close(){
      //reset for later...
      this.project = null
      this.trial = null
      this.$modal.hide(this.name)
    }
  },
  watch: {
    project () {
      this.trial = null
      this.group = null
    },
    trial () {
      this.group = null
      this.$asyncComputed.currentTrial.update()
    }
  }

}
</script>

<style scoped lang="stylus">
.modal-import-from
  padding: 25px
  position relative
  height 100%
  .close
    cursor: pointer
    height: 15px
    m-icon("cross", 15)
    position: absolute
    right: 15px
    top: 15px
    // transform: translateY(-50%)
    width: @height
  .title
    margin-bottom 20px
  .selector
    margin-bottom 20px
  
  .btn
    width 120px
    margin-left: auto;
</style>